import React from 'react';
import TextBox from "../../common/primitives/TextBox";
import Select from "../../common/primitives/Select";
import CheckBox from "../../common/primitives/CheckBox";
import Label from "../../common/primitives/Label";
import TextArea from "../../common/primitives/TextArea";
import Button from "../../common/primitives/Button";
import BaseComponent, {AjaxParam} from "../../common/BaseComponent/BaseComponent";
import styles from "./ComponentCompanyForm.scss";
import buttons from "../../common/primitives/Button.scss";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {_scrollTo} from "../../common/helpers/HelperAnimation";
import {__t} from '../../common/lang/text-resource';


class ComponentCompanyForm extends BaseComponent {
	ddsRegChecked = false;
	showDDSFields = false;
	showZDDSField = false;
	hasError = false;
	errors = {};
	newCompanyId = 'new_company_id';

	constructor(props) {
		super(props);
		this.state.componentData.companyData = this.handleDDSFlags(this.state.componentData.companyData);
	}

	getComponentState = () => ({
		companyData: this.state.componentData.companyData,
		cartId: this.state.componentData.cartId,
		editMode: this.props.editMode,
	});

	validateEikEGN = () => {
		let {companyData} = this.state.componentData;
		const actionData = {
			vat: companyData.company_eik,
			taxNumber: companyData.company_country + companyData.company_eik,
			isEIK: (companyData.eikegn === 'eik'),
			isVatRegistered: this.ddsRegChecked,
			cartId: this.state.componentData.cartId,
		};
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			const {hasVatRegistration} = data.componentData;

			companyData.hasVatRegistration = hasVatRegistration;
			if (hasVatRegistration === true) {
				this.ddsRegChecked = true;
				const selectedEUCountry = this.isCountryInEU();
				companyData = this.handleDDSFlags(companyData);
				this.state.componentData.companyData = companyData;
			}


			this.hasError = false;
			this.errors['company_eik'] = '';
			this.setState(this.state);
			return false
		};
		ajaxParam.callbackError = (errorData) => {
			const {componentErrors} = errorData;
			const errorMessage = componentErrors[0];
			this.hasError = true;
			this.errors['company_eik'] = this.messages[errorMessage] || errorMessage;
			this.setState(this.state);

			return false;
		};
		this.ajaxCall('ActionCheckVat', actionData, ajaxParam);
		return this.hasError;
	};
	validateVIES = () => {
		const {companyData} = this.state.componentData;
		const actionData = {
			taxNumber: companyData.company_tax_number,
		};
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = () => {
			this.hasError = false;
			this.errors['company_tax_number'] = '';
			this.setState(this.state);
			return false
		};

		ajaxParam.callbackError = (errorData) => {
			const {componentErrors} = errorData;
			const errorMessage = componentErrors[0];
			this.hasError = true;
			this.errors['company_tax_number'] = this.messages[errorMessage] || errorMessage;
			this.setState(this.state);

			return false;
		};
		this.ajaxCall('ActionCheckVIES', actionData, ajaxParam);
		return this.hasError;
	};
	onChange = event => {
		let componentData = this.state.componentData;
		let value = event.target.value;
		if (event.target.name === 'company_tax_number' && this.isCountryInEU().length > 0) {
			value = this.isCountryInEU()[0].vatPrefix + value.replace(this.isCountryInEU()[0].vatPrefix, '');
		}
		componentData.companyData[event.target.name] = value;
		componentData.companyData = this.handleDDSFlags(componentData.companyData);
		this.errors[event.target.name] = '';
		this.setState(Object.assign({}, this.state, {componentData: componentData}));
	};

	onChangeCountry = selectedOption => {
		let componentData = this.state.componentData;
		componentData.companyData.company_country = selectedOption.value;
		componentData.companyData.company_phone_code = selectedOption.value;
		componentData.companyData.company_eik = '';
		componentData.companyData.company_tax_number = '';
		if (this.isCountryInEU().length > 0) {
			if (componentData.companyData.company_country === 'BG') {
				if (this.ddsRegChecked) {
					componentData.companyData.company_tax_number = this.isCountryInEU()[0].vatPrefix;
				}
			} else {
				componentData.companyData.company_tax_number = this.isCountryInEU()[0].vatPrefix;
			}
		}
		this.errors['company_country'] = '';
		this.errors['company_phone_code'] = '';
		this.errors['company_eik'] = '';
		this.errors['company_tax_number'] = '';
		componentData.companyData = this.handleDDSFlags(componentData.companyData);
		this.setState(Object.assign({}, this.state, {componentData: componentData}));
	};


	onChangeSelect = (selectedOption, selectName) => {
		let componentData = this.state.componentData;
		componentData.companyData[selectName] = selectedOption.value;
		if (selectName === 'eikegn' && componentData.companyData.company_eik !== '') {
			this.validateEikEGN();
		}

		componentData.companyData = this.handleDDSFlags(componentData.companyData);
		this.errors[selectName] = '';
		this.setState(Object.assign({}, this.state, {componentData: componentData}));
	};

	onChangeVatRegistration = () => {
		let componentData = this.state.componentData;
		this.ddsRegChecked = !this.ddsRegChecked;
		componentData.companyData.company_tax_number = '';
		if (this.ddsRegChecked) {
			componentData.companyData.company_tax_number = 'BG' + componentData.companyData.company_eik;
		}
		componentData.companyData = this.handleDDSFlags(componentData.companyData);
		this.setState(Object.assign({}, this.state, {componentData: componentData}), () => {
			this.validateEikEGN();
		});

	};

	companyEikOnChange = event => {
		let componentData = this.state.componentData;
		componentData.companyData[event.target.name] = event.target.value;
		if (componentData.companyData.company_country === 'BG' && this.ddsRegChecked) {
			componentData.companyData.company_tax_number = 'BG' + event.target.value;
		}
		componentData.companyData = this.handleDDSFlags(componentData.companyData);
		this.errors['company_eik'] = '';
		this.setState(Object.assign({}, this.state, {componentData: componentData}));
	};

	handleDDSFlags = companyData => {
		this.showDDSFields = false;
		let companyEik = companyData.company_eik || '';
		let companyTaxNumber = companyData.company_tax_number || '';
		if ((typeof companyData.hasVatRegistration !== 'undefined' && companyData.hasVatRegistration) || (companyTaxNumber !== '' && companyTaxNumber !== companyEik && this.props.editMode === true)) {
			this.ddsRegChecked = true;
		}

		if (companyData.company_country === 'BG') {
			this.showDDSFields = true;
			const isEuCountry = this.isCountryInEU();
			if (this.ddsRegChecked) {
				companyData.company_tax_number = isEuCountry[0].vatPrefix + companyEik;
			} else {
				companyData.company_tax_number = '';
			}
		} else {
			const isEuCountry = this.isCountryInEU();
			if (isEuCountry.length) {
				this.showZDDSField = true;
			} else {
				this.showZDDSField = false;
				companyData.company_tax_number = '';
			}
		}
		return companyData;
	};

	orderFields = (a, b) => {
		const sortMap = {
			company_name: 1,
			company_country: 2,
			company_eik: 3,
			eikegn: 4,
			company_tax_number: 5,
			company_address: 6,
			company_city: 7,
			company_code: 8,
			company_phone: 7,
			company_phone_code: 10,
			company_mol: 11,
		};
		if (sortMap[a] < sortMap[b]) {
			return -1;
		}
		if (sortMap[a] > sortMap[b]) {
			return 1;
		}
		return 0;
	};

	componentValidate = (field) => {
		const requiredFields = {
			company_name: 1,
			company_country: 1,
			company_address: 1,
			company_city: 1,
			company_tax_number: 0,
			company_code: 0,
			company_mol: 0,
			company_phone_code: 0,
			company_phone: 0,
			eikegn: 0,
			company_eik: 0
		};

		this.hasError = false;
		this.errors = {};
		const {companyData} = this.state.componentData;
		Object.keys(companyData).map((key) => {
			const value = companyData[key];
			const isRequired = requiredFields[key];
			if (isRequired && value === '') {
				this.hasError = true;
				this.errors[key] = this.messages[`${key.toUpperCase()}_ERROR`];
			}
		});
		if (!companyData.skip_eik_check && companyData.company_country === 'BG') {
			if (!companyData.company_eik) {
				this.hasError = true;
				this.errors['company_eik'] = this.messages.COMPANY_EIK_ERROR;
			} else {
//				this.hasError = this.validateEikEGN();
			}
		}
		if (requiredFields['company_city'] === 1 && companyData.company_city.length < 3) {
			this.hasError = true;
			this.errors['company_city'] = this.messages.COMPANY_CITY_INVALID_ERROR;
		}
		if (requiredFields['company_address'] === 1 && companyData.company_address.length < 3) {
			this.hasError = true;
			this.errors['company_address'] = this.messages.COMPANY_ADDRESS_INVALID_ERROR;
		}
		if ((requiredFields['company_city'] === 1 && requiredFields['company_address'] === 1) && companyData.company_city === companyData.company_address) {
			this.hasError = true;
			this.errors['company_address'] = this.messages.COMPANY_ADDRESS_SAME_ERROR;
		}

		if (field) {
			let fieldError = this.errors[field];
			this.errors = {};
			this.errors[field] = fieldError;
		}

		this.setState(this.state, () => {
			if (this.hasError && !field) {
				let fieldId = Object.keys(this.errors).sort(this.orderFields)[0];
				if (document.querySelector(`#${fieldId}`)) {
					_scrollTo(document.querySelector(`#${fieldId}`), -150, 100, 'easeOutQuad');
				}
			}
		});
		return !this.hasError;
	};

	render() {
		const {
			companyData,
			countries,
			phones
		} = this.state.componentData;

		return (
		  <div className={styles.companyForm} data-test="company_form">
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.row} id='company_name'>
				  <div className={styles.firstCol}>
					  <label htmlFor="inv_company_name">
						  <span>* </span>
						  {__t('юридическо лице')}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  <TextBox
						name='company_name'
						error={this.errors['company_name']}
						id={'inv_company_name'}
						value={companyData.company_name}
						onChange={this.onChange}
						placeholder={__t('АБВ Трейд ООД')}
						required={true}
						onBlur={() => this.componentValidate('company_name')}/>
				  </div>
			  </div>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.row} id='company_country'>
				  <div className={styles.firstCol}>
					  <label htmlFor="inv_company_country">
						  <span>* </span>
						  {__t('държава')}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  {
						  this.props.editMode === true ?
							<span>{companyData.company_country_name_bg}</span>
							:
							<Select
							  id={'inv_company_country'}
							  selected={companyData.company_country}
							  name={'company_country'}
							  error={this.errors['company_country']}
							  options={countries}
							  onChange={this.onChangeCountry}
							  placeholder={__t('България')}
							  required={true}
							  isSearchable={true}
							  isGrouped={true}
							  onBlur={() => this.componentValidate('company_country')}/>
					  }
				  </div>
			  </div>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  {this.getDDSFields()}


			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.row} id="company_address">
				  <div className={styles.firstCol}>
					  <label htmlFor="inv_company_address">
						  <span>* </span>
						  {__t('адрес')}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  <TextArea
						id={'inv_company_address'}
						name={'company_address'}
						error={this.errors['company_address']}
						value={companyData.company_address}
						required={true}
						onChange={this.onChange}
						placeholder={__t('бул. "Д-р Г.М. Димитров" 36')}
						onBlur={() => this.componentValidate('company_address')}/>
				  </div>
			  </div>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  <div
				id='company_city'
				data-layout="row middle gutter-none"
				className={`${styles.multiColContainer} ${styles.row} ${styles.mtm5} multi-col-container`}>
				  <div
					className={styles.labelContainer}
					data-layout={`col 8 3@md first@md`}>
					  <label htmlFor="inv_company_city">
						  <span>* </span>
						  {__t('град')}
					  </label>
				  </div>
				  <div
					className={styles.labelContainer}
					data-layout={`col 4 2@md padding-right--sm`}>
					  <label htmlFor="inv_company_pc">
						  {__t('пк')}
					  </label>
				  </div>
				  <div data-layout={`col 8 5@md first@md`}>
					  <TextBox
						name={'company_city'}
						error={this.errors['company_city']}
						id={'inv_company_city'}
						placeholder={__t('София')}
						value={companyData.company_city}
						onChange={this.onChange}
						required={true}
						onBlur={() => this.componentValidate('company_city')}/>
				  </div>
				  <div data-layout={`col 4 2@md`}>
					  <TextBox
						id={'inv_company_pc'}
						name={'company_code'}
						value={companyData.company_code}
						onChange={this.onChange}
						placeholder={__t('1000')}/>
				  </div>
			  </div>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  <div className={styles.row} id='company_phone_code'>
				  <div className={styles.firstCol}>
					  <label htmlFor="inv_company_phone">
						  {__t('телефон')}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  <div data-layout='row gutter-none start'>
						  <div data-layout="col 4 padding-right--smm">
							  <Select
								selected={companyData.company_phone_code}
								name={'company_phone_code'}
								error={this.errors['company_phone_code']}
								options={phones}
								placeholder={__t('kод')}
								required={true}
								isGrouped={true}
								onChange={(selectedOption) => this.onChangeSelect(selectedOption, 'company_phone_code')}
								onBlur={() => this.componentValidate('company_phone_code')}/>
						  </div>
						  <div data-layout="col 8">
							  <TextBox
								required={true}
								value={companyData.company_phone}
								name={'company_phone'}
								error={this.errors['company_phone']}
								id={'inv_company_phone'}
								onChange={this.onChange}
								placeholder={__t('99 999 99 99')}
								onBlur={() => this.componentValidate('company_phone')}/>
						  </div>
					  </div>
				  </div>
			  </div>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  <div className={styles.row}>
				  <div className={styles.firstCol}>
					  <label htmlFor="inv_company_mol">
						  {__t('МОЛ')}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  <TextBox
						name={'company_mol'}
						id={'inv_company_mol'}
						onChange={this.onChange}
						value={companyData.company_mol}
						placeholder={__t('Иван Иванов')}/>
				  </div>
			  </div>
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  {
				this.props.showSaveButton === true &&
				<div className={styles.row}>
					<div className={styles.firstCol}/>
					<div className={styles.secondCol}>
						<div data-layout='row gutter-none end'
							 className={`${styles.mobileCenter} ${this.props.closeButtonHide === true ? styles.mb10 : ''}`}>
							<div data-layout='col 12 9@md text-left' className={styles.mobileCenter}>
								<Button
								  onClick={this.props.saveAction}
								  name='componentCompanyFormSave'
								  value={__t('Запази фирма')}/>
							</div>
						</div>
					</div>
				</div>
			  }
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  {
				this.props.closeButtonHide !== true &&
				<div className={styles.row}>
					<div className={`${styles.firstCol} ${styles.mobileHidden}`}/>
					<div className={styles.secondCol}>
						<div data-layout='row gutter-none end'
							 className={`${styles.mobileCenter} ${styles.mb10}`}>
							<div data-layout='col 12 text-left' className={styles.mobileCenter}>

								{
								  (typeof this.props.cancelButtonAction === 'function') &&
								  <Button
									className={`${buttons.buttonLink} ${buttons.action}`}
									onClick={this.props.cancelButtonAction}
									name='componentCompanyFormCancel'
									value={this.props.closeButtonText ? this.props.closeButtonText : __t('Скриване на данни за фирма')}/>
								}
							</div>
						</div>
					</div>
				</div>
			  }
		  </div>
		)
	}

	isCountryInEU = () => {
		let euCountry;
		const {countries} = this.state.componentData;
		euCountry = countries[0]['options'].filter((country) => {
			return country.value === this.state.componentData.companyData.company_country;
		});
		return euCountry;
	};

	getDDSFields = () => {
		const {companyData} = this.state.componentData;

		if (this.props.editMode === true) {
			if (this.showDDSFields) {
				return (
				  <div>

					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  <div className={styles.row}>
						  <div className={styles.firstCol}>
							  <label htmlFor="inv_company_eik_egn">
								  <span>* </span>
								  {__t('ЕИК/ЕГН')}
							  </label>
						  </div>
						  <div className={styles.secondCol}>
								<span>
									{companyData.company_eik}
								</span>
						  </div>
					  </div>

					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  <div className={`${styles.row} ${styles.ddsRow}`}>
						  <div className={`${styles.firstCol} ${styles.dinb_edit}`}>
							  <CheckBox
								name={`vatRegistration`}
								checked={this.ddsRegChecked}
								disabled={companyData.hasVatRegistration === true}
								customOnchange={this.onChangeVatRegistration}/>
						  </div>
						  <div className={styles.secondCol}>
							  {
								  (this.ddsRegChecked) ?
									<div className={styles.ddsDiv}>
										{companyData.company_tax_number}
									</div>
									:
									<Label
									  className={styles.ddsLabel}
									  htmlFor={`vatRegistration`}
									  text={__t('ДДС регистрация')}/>
							  }
						  </div>
					  </div>
					  {
						this.ddsRegChecked && companyData.hasVatRegistration === false &&
						<div className={styles.row}>
							<div className={`${styles.firstCol}`}/>
							<div className={styles.secondCol}>
								{__t('•-моля-уверете-се-че-избраната-организация-фирма-f4ddd0')}
								<br/>
								{__t('ако-не-е-регистрирана-по-ддс-премахнете-отметката5505c3')}
							</div>
						</div>
					  }
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  </div>
				);
			} else {
				return (

				  <div>

					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  <div className={styles.row}>
						  <div className={styles.firstCol}>
							  <label htmlFor="company_eik">
								  <span>* </span>
								  {__t('ЕИК/ЕГН')}
								  {/*<div data-layout="hide@md">идентификационен код</div>*/}
								  {/*<div data-layout="hide show@md">идент. код</div>*/}
							  </label>
						  </div>
						  <div className={styles.secondCol}>
								<span>
									{
										companyData.company_tax_number
									}
								</span>
						  </div>
					  </div>


					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  </div>
				);
			}
		}


		if (this.showDDSFields) {
			return (
			  <div>

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div className={styles.row} id='company_eik'>
					  <div className={styles.firstCol}>
						  <label htmlFor="inv_company_eik_egn">
							  <span>*</span>
						  </label>
					  </div>
					  <div className={styles.secondCol}>
						  <div data-layout='row gutter-none start'>
							  <div data-layout={`col 4 padding-right--smm`}>
								  <Select
									name={'eikegn'}
									selected={companyData.eikegn}
									options={[
										{value: 'eik', label: __t('ЕИК')},
										{value: 'egn', label: __t('ЕГН')},
									]}
									onChange={(selectedOption) => this.onChangeSelect(selectedOption, 'eikegn')}
									error={this.errors['company_egn_eik']}
									onBlur={() => this.componentValidate('company_egn_eik')}/>
							  </div>
							  <div data-layout={`col 8`}>
								  <TextBox
									required={true}
									id={'inv_company_eik_egn'}
									name={'company_eik'}
									error={this.errors['company_eik']}
									value={companyData.company_eik}
									onBlur={this.validateEikEGN}
									onChange={this.companyEikOnChange}
									placeholder={"9 9 9 9 9 9 9 9 9 9"}/>
							  </div>
						  </div>
					  </div>
				  </div>

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div className={`${styles.row} ${styles.vatRegContainer}`}>
					  <div className={`${styles.firstCol} ${styles.dinb}`}>
						  <CheckBox
							name={`vatRegistration`}
							checked={this.ddsRegChecked}
							disabled={companyData.hasVatRegistration === true}
							customOnchange={this.onChangeVatRegistration}/>
					  </div>
					  <div className={`${styles.secondCol} ${styles.dinb} ${styles.tax_container}`}>
						  {
							  (this.ddsRegChecked) ?
								<div className={styles.ddsDiv}>
									{companyData.company_tax_number}
								</div>
								:
								<Label
								  className={styles.ddsLabel}
								  htmlFor={`vatRegistration`}
								  text={__t('ДДС регистрация')}/>
						  }
					  </div>
				  </div>
				  {
					this.ddsRegChecked && companyData.hasVatRegistration === false &&
					<div className={styles.row}>
						<div className={styles.firstCol}/>
						<div className={styles.secondCol}>
							{__t('•-моля-уверете-се-че-избраната-организация-фирма-f4ddd0')}
							<br/>
							{__t('ако-не-е-регистрирана-по-ддс-премахнете-отметката5505c3')}
						</div>
					</div>
				  }

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  </div>
			);
		} else if (this.showZDDSField) {
			return (
			  <div>

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <label htmlFor="company_eik">
							  <span>* </span>
							  {__t('ЕИК/ЕГН')}
							  {/*<div data-layout="hide@md">идентификационен код</div>*/}
							  {/*<div data-layout="hide show@md">идент. код</div>*/}
						  </label>
					  </div>
					  <div className={styles.secondCol}>
						  <TextBox
							name={'company_eik'}
							error={this.errors['company_eik']}
							onChange={this.companyEikOnChange}
							value={companyData.company_eik}
							id={'company_eik'}
							placeholder={'9 9 9 9 9 9 9 9'}
							onBlur={() => this.componentValidate('company_eik')}/>
					  </div>
				  </div>

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div className={styles.row}>
					  <div className={styles.firstCol}/>
					  <div className={styles.secondCol}>
						  <TextBox
							name={'company_tax_number'}
							value={companyData.company_tax_number}
							onBlur={this.validateVIES}
							error={this.errors.company_tax_number}
							onChange={this.onChange}/>
					  </div>
				  </div>

				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  </div>
			)
		} else {
			return (
			  <div className={styles.row}>
				  <div className={styles.firstCol}>
					  <label htmlFor="company_eik">
						  <span>* </span>
						  {__t('ЕИК/ЕГН')}
						  {/*<div data-layout="hide@md">идентификационен код</div>*/}
						  {/*<div data-layout="hide show@md">идент. код</div>*/}
					  </label>
				  </div>
				  <div className={styles.secondCol}>
					  <TextBox
						name={'company_eik'}
						error={this.errors['company_eik']}
						value={companyData.company_eik}
						onChange={this.onChange}
						placeholder={'9 9 9 9 9 9 9 9'}
						onBlur={() => this.componentValidate('company_eik')}/>
				  </div>
			  </div>
			);
		}
	};
}


// React Context binding
ComponentCompanyForm.contextType = ContextDataStore;

export default ComponentCompanyForm;